import React from 'react';
import { exceptionState, filterText } from '../../policy/policyModel';
import { ruleText, sortRules } from '../../policy/ruleSwitches';
import JsonEditor, { jsonText } from '../JsonEditor';

const list = (v) => (Array.isArray(v) ? v : []);
const dash = (v) => (v === undefined || v === null || v === '' ? '-' : String(v));

// A policy's values, read only: what the policy says in the same fields the editor has. Used for a policy that belongs to another layer (a global
// policy seen under a customer), which is changed in that layer.
function Value({ field, doc }) {
  const value = doc[field.name];
  switch (field.type) {
    case 'filter':
      return <div>{list(value).map((f) => <span className="tag" key={`${f.label}-${f.value}`}>{`${f.label} is ${f.value}`}</span>)}</div>;
    case 'flag':
      return <div>{value === false ? 'No' : 'Yes'}</div>;
    case 'limits': {
      const known = list(field.limits).filter((l) => value && value[l.name] !== undefined);
      const extra = list(field.extra).filter((x) => value && value[x.name]);
      if (!known.length && !extra.length) return <div>-</div>;
      return (
        <table aria-label={field.label}>
          <tbody>
            {known.map((l) => <tr key={l.name}><td>{l.label}</td><td className="strong">{value[l.name]}</td></tr>)}
            {extra.map((x) => <tr key={x.name}><td>{x.label}</td><td className="strong">{value[x.name]}</td></tr>)}
          </tbody>
        </table>
      );
    }
    case 'rules':
      return list(value).length === 0 ? <div>No rules.</div> : (
        <table aria-label={field.label}>
          <thead><tr><th>Program</th><th>Does</th><th>On</th></tr></thead>
          <tbody>
            {sortRules(list(value)).map((r) => <tr key={r.key}><td className="mono">{r.key}</td><td>{ruleText(r)}</td><td>{r.enabled === false ? 'off' : 'on'}</td></tr>)}
          </tbody>
        </table>
      );
    case 'json':
      return value === undefined || value === null ? <div>-</div> : <JsonEditor value={jsonText(value)} readOnly label={field.label} />;
    case 'exception': {
      if (!value) return <div>None.</div>;
      const state = exceptionState(value);
      return <div>{`${value.reason} (approved by ${value.approvedBy}, ${state.text})`}</div>;
    }
    default:
      return <div>{dash(value)}</div>;
  }
}

// Props: spec (the kind's description), doc (the policy), onEditInGlobal (switch to the layer it belongs to).
export default function PolicyView({ spec, doc, onEditInGlobal }) {
  return (
    <div className="policy-view" role="group" aria-label={`${spec.title} values`}>
      <div className="help">This policy belongs to the global layer, so it is changed there. It applies here as it is{doc.filter ? `, to machines where ${filterText(doc)}` : ''}.</div>
      {spec.fields.map((field) => (
        <div className="field" key={field.name}>
          <div className="label">{field.label}</div>
          <Value field={field} doc={doc} />
        </div>
      ))}
      <div className="editor-actions">
        <button type="button" className="btn btn-primary btn-sm" onClick={onEditInGlobal}>Edit in Global</button>
      </div>
    </div>
  );
}
